import { render, staticRenderFns } from "./DeliveriesTableRow.vue?vue&type=template&id=1c5da790&"
import script from "./DeliveriesTableRow.vue?vue&type=script&lang=ts&"
export * from "./DeliveriesTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports